import { render, staticRenderFns } from "./OrderEvaluate.vue?vue&type=template&id=2febda60&scoped=true"
import script from "./OrderEvaluate.vue?vue&type=script&lang=js"
export * from "./OrderEvaluate.vue?vue&type=script&lang=js"
import style0 from "./OrderEvaluate.vue?vue&type=style&index=0&id=2febda60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2febda60",
  null
  
)

export default component.exports